import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"48\" height=\"48\" fill=\"#F1F1F1\" rx=\"12\"></rect><g clip-path=\"url(#i-1996491944__a)\"><path fill=\"#59AD3B\" d=\"M24.021 24.035c-3.309 0-6-2.69-6-6 0-3.309 2.692-6 6-6s6 2.691 6 6c0 3.31-2.691 6-6 6ZM26 30.22v-4.184h-5.021v4.277c.595.346 1 .984 1 1.723a2 2 0 1 1-4 0c0-.738.405-1.376 1-1.723v-4.275A5.005 5.005 0 0 0 14 31.035v5h10v-3c0-1.302.839-2.402 2-2.816Zm3-4.184h-1v4.184c1.161.414 2 1.514 2 2.816v3h4v-5c0-2.757-2.243-5-5-5Zm-2 6a1 1 0 0 0-1 1v3h2v-3a1 1 0 0 0-1-1Z\"></path></g><defs><clipPath id=\"i-1996491944__a\"><path fill=\"#fff\" d=\"M12 12.035h24v24H12z\"></path></clipPath></defs>", 3)
  ]))]))
}
export default { render: render }